import React from "react";
import styled from "styled-components";
import {
  FaPhone,
  FaEnvelope,
  FaFacebook,
  FaInstagram,
  FaWhatsapp,
  FaTelegram,
} from "react-icons/fa";
import { MailOutlined, UserOutlined } from "@ant-design/icons";
import { Input, Button, Form } from "antd";
import { contactAdmin } from "../api/contactAPI";
import { EMAIL, PHONE_NUMBER, TELE_USERNAME } from "../envVar";

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 85vh;
  background-color: #f5f5f5;
  margin: 0 auto;
`;

const ContactWrapper = styled.div`
  width: 80vw;
  margin: 0 auto;
  display: flex;

  @media (max-width: 1100px) {
    width: 100%;
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }
`;

const Section = styled.div`
  background-color: #fff;
  padding: 10%;
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
  text-align: center;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  width: 50vw;

  &:not(:last-child) {
    margin-right: 20px;
  }

  @media (max-width: 1100px) {
    width: 100%;
    gap: 20px;
    &:not(:last-child) {
      margin-right: 0;
    }
  }
`;

const Title = styled.h2`
  color: #333;
  font-size: 24px;
  margin-bottom: 20px;
`;

const ContactInfo = styled.p`
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #555;
  font-size: 16px;

  svg {
    margin-right: 5px;
  }
`;

const SocialMediaIcons = styled.div`
  display: flex;
  align-items: center;
  margin-top: 20px;

  & > * {
    margin-right: 10px;
    font-size: 20px;
    color: #555;
    cursor: pointer;
    transition: color 0.3s;

    &:hover {
      color: #333;
    }
  }
`;

const openFacebookPage = () => {
  window.open("https://www.facebook.com/example", "_blank");
};

const openInstagramPage = () => {
  window.open("https://www.instagram.com/example", "_blank");
};

const openWhatsappChat = () => {
  window.open(`https://api.whatsapp.com/send?phone=01117240616`, "_blank");
};

const openTelegramChat = () => {
  window.open(`https://t.me/${TELE_USERNAME}`, "_blank");
};

const ContactPage = () => {
  const handleSubmit = async (values) => {
    const data = await contactAdmin(values);
    console.log(data);
  };

  return (
    <Container>
      <ContactWrapper>
        <Section>
          <Title>Hubungi Kami</Title>
          <ContactInfo>
            <FaPhone />
            {PHONE_NUMBER}
          </ContactInfo>
          <ContactInfo>
            <FaEnvelope />
            {EMAIL}
          </ContactInfo>
          <SocialMediaIcons>
            <FaFacebook onClick={openFacebookPage} />
            <FaInstagram onClick={openInstagramPage} />
            <FaWhatsapp onClick={openWhatsappChat} />
            <FaTelegram onClick={openTelegramChat} />
          </SocialMediaIcons>
        </Section>
        <Section>
          <Title>Hantar satu mesej</Title>
          <Form name="contact-form" onFinish={handleSubmit}>
            <Form.Item
              name="fullName"
              rules={[{ required: true, message: "Please enter your name" }]}
            >
              <Input prefix={<UserOutlined />} placeholder="Name" />
            </Form.Item>
            <Form.Item
              name="email"
              rules={[
                { required: true, message: "Please enter your email" },
                { type: "email", message: "Please enter a valid email" },
              ]}
            >
              <Input prefix={<MailOutlined />} placeholder="Email" />
            </Form.Item>
            <Form.Item
              name="message"
              rules={[{ required: true, message: "Please enter your message" }]}
            >
              <Input.TextArea placeholder="Message" rows={5} />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit">
                Send
              </Button>
            </Form.Item>
          </Form>
        </Section>
      </ContactWrapper>
    </Container>
  );
};

export default ContactPage;
